export const DS_CLASSNAME_MAP = {
  root: 'root',
  content: 'content',
};
